export default {
  Contact: 'Contacto',
  Contact_information: 'Información de contacto',
  Email: 'Correo Electronico',
  Full_name: 'Nombre completo',
  Telephone_contact: 'Telefono de contacto ',
  contactWithUs: 'Ponte en contacto con nosotros',
  Message: 'Mensaje',
  SEND_MESSAGE: 'ENVIAR MENSAJE'

}